// محتوای سوالات متداول — بعداً در صورت نیاز می‌توان از یک اندپوینت واقعی (مثلاً /company/faq/) گرفت
// و همین ساختار (category + items) را از پاسخ سرور پر کرد
export interface FaqItem { q: string; a: string }
export interface FaqCategory { id: string; label: string; items: FaqItem[] }

export const faqCategories: FaqCategory[] = [
  {
    id: "booking",
    label: "رزرو بلیط بین‌شهری",
    items: [
      {
        q: "چطور بلیط تاکسی بین‌شهری رزرو کنم؟",
        a: "از صفحه اصلی بلینو، شهر مبدأ، مقصد و تاریخ سفر را انتخاب کرده و روی «جستجوی بلیط» بزنید. فهرست سرویس‌های عادی و اختصاصی (دربستی) نمایش داده می‌شود. با انتخاب صندلی دلخواه و پرداخت آنلاین، بلیط شما صادر خواهد شد.",
      },
      {
        q: "تفاوت سفر عادی و اختصاصی (دربستی) چیست؟",
        a: "در سفر عادی، شما هزینه یک یا چند صندلی را می‌پردازید و سایر صندلی‌ها در اختیار مسافران دیگر است. در سفر اختصاصی (دربستی)، کل ظرفیت خودرو سواری (۳ تا ۴ صندلی) به طور کامل در اختیار شما قرار می‌گیرد و مسافر متفرقه سوار نخواهد شد.",
      },
      {
        q: "آیا امکان انتخاب صندلی در سواری بین‌شهری وجود دارد؟",
        a: "بله، در فرآیند رزرو سفر عادی، نقشه صندلی‌های خودرو شامل صندلی جلو و صندلی‌های عقب نمایش داده می‌شود و می‌توانید صندلی مورد نظر خود را آزادانه انتخاب کنید.",
      },
      {
        q: "صندلی انتخاب‌شده تا چه مدت برای پرداخت رزرو می‌ماند؟",
        a: "صندلی یا خودروی انتخابی شما به مدت ۱۵ دقیقه به حالت رزرو موقت درمی‌آید تا فرصت کافی برای تکمیل فرآیند پرداخت اینترنتی را داشته باشید.",
      },
      {
        q: "چه مدت قبل از حرکت باید در ایستگاه حضور داشته باشم؟",
        a: "توصیه می‌شود حداقل ۱۵ دقیقه پیش از زمان حرکت مندرج در بلیط، در ایستگاه یا مبدأ حرکت حاضر باشید تا هماهنگی با راننده به راحتی انجام شود.",
      },
    ],
  },
  {
    id: "cancellation",
    label: "کنسلی و استرداد بلیط",
    items: [
      {
        q: "شرایط و جریمه کنسلی بلیط تاکسی بین‌شهری چگونه است؟",
        a: "از زمان خرید تا یک ساعت پیش از ساعت حرکت، تنها ۱۰ درصد از مبلغ بلیط کسر می‌شود. در فاصله یک ساعت مانده تا حرکت، ۵۰ درصد مبلغ کسر می‌شود. پس از ساعت حرکت، امکان کنسلی و استرداد وجه وجود ندارد.",
      },
      {
        q: "مبلغ استرداد شده پس از کنسلی چه زمانی به حساب برمی‌گردد؟",
        a: "مبلغ پرداختی پس از کسر درصد جریمه، حداکثر ظرف ۲۴ الی ۴۸ ساعت کاری به شماره حساب یا کارت بانکی پرداخت‌کننده واریز خواهد شد.",
      },
      {
        q: "اگر سرویس توسط شرکت مسافربری یا راننده لغو شود چه می‌شود؟",
        a: "در صورتی که سفر به دلایل فنی یا توسط شرکت ارائه‌دهنده سرویس لغو شود، ۱۰۰ درصد مبلغ پرداختی بدون هیچ‌گونه کسری به حساب کاربر عودت داده می‌شود.",
      },
    ],
  },
  {
    id: "door_to_door",
    label: "سفر درب‌به‌درب",
    items: [
      {
        q: "سرویس درب‌به‌درب (Door-to-Door) چگونه کار می‌کند؟",
        a: "در سرویس درب‌به‌درب، راننده سواری بین‌شهری شما را دقیقاً از درب منزل یا محل کار در شهر مبدأ سوار کرده و بدون نیاز به مراجعه به ترمینال، مستقیماً به آدرس مشخص‌شده در شهر مقصد می‌رساند.",
      },
      {
        q: "مزیت سفر درب‌به‌درب نسبت به سفر ترمینالی چیست؟",
        a: "حذف هزینه‌ها و اتلاف وقت تاکسی‌های درون‌شهری، راحتی جابه‌جایی چمدان‌ها، عدم معطلی در ترمینال، و تجربه سفری اختصاصی و امن از درِ مبدا تا درِ مقصد.",
      },
      {
        q: "سرویس درب‌به‌درب بلینو در چه شهرهایی فعال است؟",
        a: "در حال حاضر در خطوط اصلی استان کرمان از جمله مسیرهای کرمان به سیرجان، رفسنجان، بم و جیرفت فعال بوده و به زودی در سراسر کشور گسترش می‌یابد.",
      },
    ],
  },
  {
    id: "tracking",
    label: "رهگیری مرسوله",
    items: [
      {
        q: "چطور مرسوله خودم را رهگیری کنم؟",
        a: "کافیست از صفحه اصلی یا بخش «رهگیری بار»، کد رهگیری مرسوله یا شماره موبایل ثبت‌شده هنگام ارسال را وارد کنید. وضعیت لحظه‌ای بار بلافاصله نمایش داده می‌شود.",
      },
      {
        q: "کد رهگیری را از کجا پیدا کنم؟",
        a: "کد رهگیری روی رسید ارسال یا پیامک تأییدیه‌ای که هنگام ثبت بار دریافت کرده‌اید درج شده است. در صورت گم شدن رسید، می‌توانید با شماره موبایل فرستنده یا گیرنده جستجو کنید.",
      },
      {
        q: "چرا وضعیت مرسوله من به‌روزرسانی نمی‌شود؟",
        a: "به‌روزرسانی وضعیت معمولاً در هر توقف بار (بارگیری، ترانزیت، تحویل) ثبت می‌شود. اگر بیش از ۱۲ ساعت تغییری مشاهده نکردید، از طریق صفحه «تماس با پشتیبانی» با ما در ارتباط باشید.",
      },
    ],
  },
  {
    id: "shipping",
    label: "ارسال و تحویل بار",
    items: [
      {
        q: "مرسوله من چند ساعته به مقصد می‌رسد؟",
        a: "به دلیل جابه‌جایی توسط خودروهای سواری بین‌شهری خطی، مرسولات در کوتاه‌ترین زمان ممکن (معمولاً بین ۱ تا ۳ ساعت در مسیرهای همجوار) به مقصد می‌رسند.",
      },
      {
        q: "تفاوت تحویل «درب مقصد» و «انبار ایستگاه» چیست؟",
        a: "در تحویل به انبار ایستگاه، گیرنده با ارائه کد تحویل و مشخصات هویتی بار را از دفتر یا انبار مقصد تحویل می‌گیرد. در تحویل درب به درب، بسته توسط راننده یا پیک به آدرس دقیق گیرنده منتقل می‌شود.",
      },
      {
        q: "آیا مرسوله من بیمه است؟",
        a: "بله، بلینو تمامی مرسولات ثبت‌شده را بدون دریافت هزینه مازاد تا سقف ۲ میلیون تومان بیمه می‌کند. در صورت بروز هرگونه خسارت در طول مسیر، خسارت وارده جبران خواهد شد.",
      },
      {
        q: "هزینه ارسال بار چطور محاسبه می‌شود؟",
        a: "هزینه بار بر اساس وزن، حجم، مسافت مبدأ تا مقصد و نوع سرویس تحویل محاسبه شده و پیش از ارسال، به صورت شفاف اعلام می‌گردد.",
      },
    ],
  },
  {
    id: "issues",
    label: "مشکلات و شکایات",
    items: [
      {
        q: "اگر مرسوله‌ام آسیب دیده یا گم شده باشد چه کنم؟",
        a: "از صفحه «ثبت شکایت» با ذکر کد رهگیری، شرح ماجرا را ثبت کنید. تیم پشتیبانی موضوع را بررسی و در سریع‌ترین زمان ممکن با شما تماس می‌گیرد.",
      },
      {
        q: "اگر راننده با تأخیر حرکت کند یا سفر ناهماهنگ باشد چه کنم؟",
        a: "شما می‌توانید از طریق تماس با شماره ۰۹۰۰۵۵۲۰۱۵۳ یا پشتیبانی آنلاین، موضوع را گزارش دهید تا تیم عملیات بلینو فوراً پیگیری کند.",
      },
    ],
  },
];
